var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.price > 0)?_c('span',[_vm._v(" € "+_vm._s((Math.round((_vm.price * _vm.amount + Number.EPSILON) * 100) / 100) .toFixed(2) .replace('.', ','))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }